export default "__VITE_ASSET__fbbc17f0__"